__turbopack_context__.v({
  "selected": "UserMenu-module-scss-module__Yp8omG__selected",
  "wrapper": "UserMenu-module-scss-module__Yp8omG__wrapper",
});
